export const QUERY_STALE_TIME_DEFAULT = 600_000
export const ONE_MINUTE = 60_000
